import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=31a06e62&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a06e62')) {
      api.createRecord('31a06e62', component.options)
    } else {
      api.reload('31a06e62', component.options)
    }
    module.hot.accept("./ChangePasswordView.vue?vue&type=template&id=31a06e62&", function () {
      api.rerender('31a06e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/ChangePasswordView.vue"
export default component.exports